<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
<div class="relative">
  <div class="vx-navbar-wrapper navbar-full p-0">
    <vs-navbar class="navbar-custom navbar-skelton" :class="navbarClasses"  :style="navbarStyle" :color="navbarColor">

      <div class="inputDiv">
        <vs-select autocomplete class="selectExample" v-model="selectedCompany">
          <vs-select-item :key="index" :value="item.client_company_id" :text="item.company_name" v-for="(item,index) in companies" />
        </vs-select>
      </div>

      <router-link tag="div" to="/" class="vx-logo cursor-pointer mx-auto flex items-center">
        <logo class="w-10 mr-4 fill-current text-primary" />
        <span class="vx-logo-text text-primary">IT Operations<p style="font-size: 3.2mm">Management System</p></span>
      </router-link>

      <profile-drop-down />

      <vs-button class="p-1 mr-3 ml-3" color="dark" type="border" @click="zoomIn">&nbsp;+&nbsp;</vs-button>
      <vs-button class="p-1 mr-3" color="dark" type="border" @click="zoomOut">&nbsp;-&nbsp;</vs-button>

      <i18n :display-text="false"/>

    </vs-navbar>
  </div>
</div>
</template>

<script>
import Bookmarks            from "./components/Bookmarks.vue"
import SearchBar            from "./components/SearchBar.vue"
import NotificationDropDown from "./components/NotificationDropDown.vue"
import ProfileDropDown      from "./components/ProfileDropDown.vue"
import Logo                 from "../Logo.vue"
import vSelect from 'vue-select'
import I18n from "./components/I18n";

export default {
  name: "the-navbar-horizontal",
  props: {
    logo: { type: String                                                                                                          },
    navbarType: {
      type: String,
      required: true
    }
  },
  components: {
    Logo,
    Bookmarks,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
    'v-select': vSelect,
    I18n,
  },
  data() {
    return {
      companies: [],
      selectedCompany: 0,
      changingEnabled: false,
    }
  },
  methods: {
    zoomIn() {
      this.$store.dispatch('zoomIn');
    },
    zoomOut(){
      this.$store.dispatch('zoomOut');
    },
    updateClients() {
      const thisIns = this;
      this.$http.get('/api/v1/clients')
              .then(function (response) {
                thisIns.companies = response.data;
                thisIns.selectedCompany = thisIns.$store.getters.userData.client_company_id;
                for(let x = 0; x < thisIns.companies.length; x++) {
                  if(thisIns.companies[x].selected) {
                    thisIns.selectedCompany = thisIns.companies[x].client_company_id;
                  }
                }

                thisIns.$nextTick(() => {
                  thisIns.changingEnabled = true;
                });

              })
              .catch(function (error) {
                thisIns.$vs.notify({
                  title:'Error',
                  text: error,
                  color:'danger',
                  iconPack: 'feather',
                  icon:'icon-alert-circle'})
              });
    }
  },
  watch: {
    selectedCompany() {

      if (!this.changingEnabled) return;

      const thisIns = this;

      this.$http.post('/api/v1/selectClient/', {
        client_company_id: thisIns.selectedCompany,
      }).then(function (response) {
        thisIns.$store.dispatch('updateUserData', response.data);
        localStorage.setItem('userData', JSON.stringify(response.data));
        thisIns.$router.push({ name: 'allTasks'});
        location.reload();
      }).catch(function () {
        thisIns.$vs.notify({
          title:'Error',
          text: "Change failed",
          color:'danger',
          iconPack: 'feather',
          icon:'icon-alert-circle'})
      });

    }
  },
  computed: {
    navbarColor() {
      let color = "#fff";
      if (this.navbarType === "sticky") color = "#f7f7f7";
      else if (this.navbarType === 'static') {
        if (this.scrollY < 50) {
          color = "#f7f7f7"
        }
      }

      this.isThemedark === "dark" ? color === "#fff" ? color = "#10163a" : color = "#262c49" : null

      return color
    },
    isThemedark()          { return this.$store.state.theme                                                                       },
    navbarStyle()          { return this.navbarType === "static" ? {transition: "all .25s ease-in-out"} : {}                      },
    navbarClasses()        { return this.scrollY > 5 && this.navbarType === "static" ? null : "d-theme-dark-light-bg shadow-none" },
    scrollY()              { return this.$store.state.scrollY                                                                     },
    verticalNavMenuWidth() { return this.$store.state.verticalNavMenuWidth                                                        },
    windowWidth()          { return this.$store.state.windowWidth                                                                 },
  },
  created() {

    this.updateClients();

  }
}

</script>
<style lang="scss">

  .theme-dark .inputDiv input {
    background: #262c49
  }

</style>

